import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import type { Raster } from '@/modules/Editor/models/raster/Raster'
import type { View } from '@/modules/Editor/views/view'

/**
 * Given a classId, finds if there is an annotation associated with that
 * class on the given raster. Returns it if it finds one.
 * @param view The view on which the raster lives.
 * @param raster The raster object.
 * @param classId The classId to query
 * @returns A mask annotation on the raster with the given classId, if available.
 */
export function getAnnotationForClassIdOnRaster(
  view: View,
  raster: Raster,
  classId: number,
): Annotation | undefined {
  const annotationId = raster.getAnnotationIdByClassId(classId)
  if (!annotationId) {
    return
  }

  return view.annotationManager.getAnnotation(annotationId)
}
